import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AzzurroTable, SimpleButtonComponent, SimpleInputComponent, TitleContentComponent } from 'ngx-zcs-components';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { IonicModule } from '@ionic/angular';

import { BlockTitleComponent } from '../components/block-title/block-title.component';
import { AlertRegistryService } from './alert-registry.service';
import { AlertRegistryComponent } from './alert-registry.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';

@NgModule({
  imports: [
    AzzurroTable,
    BlockTitleComponent,
    CommonModule,
    FormsModule,
    IonicModule,
    MatCheckboxModule,
    MatChipsModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatPaginatorModule,
    MatSelectModule,
    ReactiveFormsModule,
    SimpleButtonComponent,
    SimpleInputComponent,
    TitleContentComponent,
  ],
  declarations: [AlertRegistryComponent],
  exports: [AlertRegistryComponent],
  providers: [
    AlertRegistryService,
  ],
})
export class AlertRegistryComponentModule {}
